import React, { forwardRef } from 'react'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'

const DEFAULT_CLASS_NAME = 'ui-react-select'
const DEFAULT_PREFIX = 'ui-select'

const mergeClassNames = (...values) => values.filter(Boolean).join(' ')

const withGlobalSelectProps = (Component) =>
  forwardRef(({ className, classNamePrefix, menuPortalTarget, styles, ...props }, ref) => (
    <Component
      ref={ref}
      className={mergeClassNames(DEFAULT_CLASS_NAME, className)}
      classNamePrefix={classNamePrefix || DEFAULT_PREFIX}
      menuPortalTarget={menuPortalTarget || (typeof document !== 'undefined' ? document.body : null)}
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
        ...styles,
      }}
      {...props}
    />
  ))

export const AppSelect = withGlobalSelectProps(Select)
export const AppCreatableSelect = withGlobalSelectProps(CreatableSelect)

export default AppSelect
